export default __webpack_public_path__ + "static/media/shyam.833411aa.jpg";